export default {
  header: {
    title: 'Great! You get the following for free with your order:',
    subtitle: 'We will apply the discount during the checkout process.',
  },
  footer: {
    buttons: {
      no_thanks: 'No, thanks',
      add_to_basket: 'Add to basket',
    },
  },
};
